import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BotoneraConfederaciones from './BotoneraConfederaciones.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import { EsObjeto } from '../funciones/Funciones.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './CuadroPaises.module.css';

const CuadroPaises = (props) => {
  const titulo = props.titulo;
  const incluirPrincipales = EsObjeto(props.incluirPrincipales) ? props.incluirPrincipales : false;
  const pathLinks = props.pathLinks;
  const [principales, setPrincipales] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (incluirPrincipales) {
      fetchData('paises?principales=true', setPrincipales);
    } else {
      setPrincipales(null);
    }
  }, [incluirPrincipales, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos titulo={titulo} mostrar={true} isCargando={isCargando} error={erroresGetLista}>
        {principales && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Principales</span>
            {principales.map((pais) => (
              <Link className={`${styles.listItem}`} key={pais.id} to={pathLinks + pais.id}>
                {pais.nombre}
              </Link>
            ))}
          </React.Fragment>
        )}
        <span className={`${styles.titulo}`}>Por confederación</span>
        <div className={`${styles.botoneraConfederaciones}`}>
          <BotoneraConfederaciones pathLinks={pathLinks} />
        </div>
      </CuadroDatos>
    </div>
  );
};

export default CuadroPaises;
